import { useId, useState } from 'react';
import {
  useFloating,
  autoUpdate,
  offset,
  flip,
  shift,
} from '@floating-ui/react-dom';
import mergeRefs from 'react-merge-refs';

export const useTooltip = (ref, props) => {
  const { placement = 'bottom', text, label, ...rest } = props;

  const [isOpen, setIsOpen] = useState(false);
  const { x, y, reference, floating, strategy } = useFloating({
    middleware: [
      offset({
        mainAxis: 4,
      }),
      flip(),
      shift(),
    ],
    placement,
    whileElementsMounted: autoUpdate,
  });

  const id = useId();
  const tooltipId = 'tooltip' + id;

  const openTooltip = () => setIsOpen(true);
  const closeTooltip = () => setIsOpen(false);

  const tooltipProps = () => {
    const rps = {
      id: tooltipId,
      role: 'tooltip',
    };

    const rct = {
      ref: mergeRefs([ref, floating]),
      style: {
        position: strategy,
        top: y ?? 0,
        left: x ?? 0,
      },
      ...rest,
    };

    return {
      ...rps,
      ...rct,
    };
  };

  const referenceProps = () => {
    const rps = {
      'aria-label': label || text,
      'aria-describedby': tooltipId,
    };

    const kbd = {
      onBlur: closeTooltip,
      onFocus: openTooltip,
      onMouseEnter: openTooltip,
      onMouseLeave: closeTooltip,
    };

    const rct = {
      ref: reference,
    };

    return {
      ...rps,
      ...kbd,
      ...rct,
    };
  };

  return {
    isOpen,
    tooltipProps,
    referenceProps,
  };
};
